export const ENVS = {
  // Ethereum Mainnet
  // CONTRACT_ADDRESS: "0x81ccd917D5eB9f4631Dfe255e75A706614e028c5",
  // CHAIN_ID: "0x1",

  // Rinkeby Testnet
  CONTRACT_ADDRESS: "0x09c0C4D22E6BCa527d12676a320871e8589d3098",
  CHAIN_ID: "0x4",
}
